<template>  
  <transition name="fade">
    <div class="position-relative" style="z-index: 1037">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-bottom d-block nav-bottom" style="bottom:0;top: 0">
          <div class="custom-container-fluid px-0" style="box-shadow: 1px 0px 6px 2px #dfdfdf4f">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white box-shadow-main popup-scroll scroll-hide-mobile popup-scroll-body" style="height: 100vh">
                  <div class="bg-white pb-4 mb-3">
                    <div class="w-100">
                      <img src="../../assets/img/icon/cancel.png" class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-4 cursor-pointer position-absolute" width="33" @click="detailRoom()" style="z-index: 1038">
                      <div class="">
                        <flickity ref="flickity" class="room-detail text-center" :options="flickityOptions">
                          <div class="carousel-cell w-100">
                            <div class="w-100" style="height: 230px !important;">
                              <img src="../../assets/img/hotel/room1.jpg" class="img-fit" height="150">
                            </div>
                          </div>
                          <div class="carousel-cell w-100">
                            <div class="w-100" style="height: 230px !important;">
                              <img src="../../assets/img/hotel/room2.jpg" class="img-fit" height="150">
                            </div>
                          </div>
                          <div class="carousel-cell w-100">
                            <div class="w-100" style="height: 230px !important;">
                              <img src="../../assets/img/hotel/room3.jpg" class="img-fit" height="150">
                            </div>
                          </div>
                        </flickity>
                        <div class="container px-4">
                          <div class="row no-gutters">
                            <div class="col-12">
                              <p class="mb-0 body-2-2 text-20 font-bold">Deluxe Room</p>
                            </div>
                          </div>
                          <img src="../../assets/img/icon/tour.png" class="d-inline-block position-relative" width="60" style="top: -2px;">
                          <p class="mb-0 body-2-2 text-12 font-bold d-inline-block">4 <span class="body-2 font-regular text-12">(1,323)</span></p>
                          <div class="">
                            <div class="row mt-3">
                              <div class="col-6 mb-2">
                                <p class="mb-1 body-2 font-regular text-12">Room size</p>
                                <p class="mb-0 body-2-2 text-14 font-bold"><i class="iconsmind-Maximize mr-1"></i>65m²</p>
                              </div>
                              <div class="col-6 mb-2">
                                <p class="mb-1 body-2 font-regular text-12">Bed type</p>
                                <p class="mb-0 body-2-2 text-14 font-bold"><i class="iconsmind-Chair mr-1"></i>One bed</p>
                              </div>
                              <div class="col-6 mb-2">
                                <p class="mb-1 body-2 font-regular text-12">Max Guests</p>
                                <p class="mb-0 body-2-2 text-14 font-bold"><i class="iconsmind-MaleFemale mr-1"></i>2 Guests</p>
                              </div>
                            </div>
                            <!-- For Room Type Packages -->
                            <template>
                              <!-- Inclusions -->
                              <div class="mb-2">
                                <p class="pt-3 mb-2 body-3-3 text-16 font-bold">Inclusions</p>
                                <ul class="mb-0 body-3-3 text-14 font-regular">
                                  <li>2 nights stay at any room</li>
                                  <li>Include breakfast</li>
                                  <li>ATV riding</li>
                                  <li>20% disc. for Spa</li>
                                  <li>30% disc. F&B</li>
                                </ul>
                              </div>
                              <!-- Package include -->
                              <div class="mb-2">
                                <p class="pt-3 mb-2 body-3-3 text-16 font-bold">Extra Benefits</p>
                                <ul class="mb-0 body-3-3 text-14 font-regular">
                                  <li>Premium Airport Transfer x 1 car(s)</li>
                                  <li>1 Hour Traditional Massage x 2 pax(s)</li>
                                  <li>Candle Light Dinner x 1 couple(s)</li>
                                </ul>
                              </div>
                            </template>
                            <p class="pt-3 mb-2 body-3-3 text-16 font-bold">Description</p>
                            <p class="mb-0 body-3-3 text-14 font-regular">The Grand Deluxe Room provides a restful environment to unwind after a busy day spent exploring the sights of Ubud. It is a cosy base featuring clean-line furnishings, a smart en-suite bathroom and a decorative wall that showcases Bali’s creative legacy. A private terrace or balcony blends seamlessly into the outdoors providing extra space to sit and relax.</p>
                            <p class="pt-4 mb-3 body-3-3 text-16 font-bold">Include</p>
                            <div class="d-block">
                              <div class="d-inline-block mr-2">
                                <p class="mb-0 body-2 text-14 font-regular text-truncate text-green"><i class="iconsmind-Coffee text-green mr-1"></i>Breakfast</p>
                              </div>
                              <div class="d-inline-block mr-2">
                                <p class="mb-0 body-2 text-14 font-regular text-truncate text-green"><i class="iconsmind-Wifi text-green mr-1"></i>Wifi</p>
                              </div>
                              <div class="d-inline-block mr-2">
                                <p class="mb-0 body-2 text-14 font-regular text-truncate text-green"><i class="iconsmind-Hour text-green mr-1"></i>Free Cancellation</p>
                              </div>
                            </div>
                            <p class="pt-4 mb-2 body-3-3 text-16 font-bold">Facilities</p>
                            <Facilities></Facilities>
                            <p class="mb-2 body-3-3 text-16 font-bold">About</p>
                            <div class="rounded-4 p-3 bg-light-page">
                              <div class="row">
                                <div class="col-6">
                                  <p class="mb-0 body-2 font-regular text-12">Check-in time</p>
                                  <p class="mb-0 body-2-2 font-bold text-14">13.00</p>
                                </div>
                                <div class="col-6">
                                  <p class="mb-0 body-2 font-regular text-12">Check-out time</p>
                                  <p class="mb-0 body-2-2 font-bold text-14">12.00</p>
                                </div>
                              </div>
                            </div>
                            <p class="pt-4 mb-2 body-3-3 text-16 font-bold">Room Policy</p>
                            <p class="mb-1 body-3-3 text-14 font-regular"><i class="iconsmind-Clock-Back mr-2"></i>Non-refundable</p>
                            <p class="mb-1 body-3-3 text-14 font-regular"><i class="iconsmind-Over-Time2 mr-2"></i>Cannot be exchanged if it is past time</p>
                          </div>
                          <div class="height-100px"></div>
                          <div class="position-relative" style="z-index: 1037">
                            <div class="row no-gutters justify-content-center">
                              <div class="fixed-bottom d-block nav-bottom" style="bottom:0px">
                                <div class="custom-container-fluid px-0">
                                  <div class="row justify-content-center no-gutters">
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                                      <div class="container px-4 py-2 bg-white box-shadow-footer">
                                        <template>
                                          <div class="w-100 text-right mb-1 d-inline-block" >
                                            <p class="mb-0 body-2-2 text-14 font-semibold d-inline-block float-left cursor-pointer">Starting from :</p>
                                            <p class="mb-0 body-2-2 text-16 font-bold text-orange d-block cursor-pointer">IDR 420.000</p>
                                            <p class="mb-0 body-2 text-12 font-regular d-block">/per room per night</p> 
                                            </div>
                                        </template>
                                        <button type="button" @click="detailRoom()" class="button-secondary w-100">See Rates</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import Flickity from 'vue-flickity';
  import Facilities from '@/components/dev/Facilities';

  export default{
    components:{
      Flickity,
      Facilities
    },
    data(){
      return{
        detail_room: false,
        flickityOptions: {
          initialIndex: 0,
          autoPlay: 3000,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: true,
          draggable: true,
          wrapAround: true,
        },
      }
    },
    methods:{
      detailRoom(){
        this.$emit('closeDetailRoom');
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/dev/RoomTypeDetailMobile.vue